import { render, staticRenderFns } from "./MarginBtn.vue?vue&type=template&id=b90d2b90&scoped=true&"
import script from "./MarginBtn.vue?vue&type=script&lang=js&"
export * from "./MarginBtn.vue?vue&type=script&lang=js&"
import style0 from "./MarginBtn.vue?vue&type=style&index=0&id=b90d2b90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90d2b90",
  null
  
)

export default component.exports